// Presentation estimates only. The API owns every reveal, payout and wallet mutation.
export function previewMultiplier(mines, picks, edgePct) {
  if (edgePct == null || !Number.isInteger(mines) || mines < 1 || mines > 24 || picks < 1 || picks > 25 - mines) return null;
  let result = 1 - edgePct / 100;
  for (let i = 0; i < picks; i++) result *= (25 - i) / (25 - mines - i);
  return Math.round(result * 10000) / 10000;
}

export function roundSnapshot(data, fallback = {}) {
  const status = data.status === "cashed" ? "won" : data.status || fallback.status || "active";
  return {
    ...fallback, ...data, status,
    round_id: data.round_id || fallback.round_id,
    revealed: data.revealed || fallback.revealed || [],
    // Hidden positions are never needed or retained while the round is active.
    mine_positions: status === "active" ? [] : data.mine_positions || fallback.mine_positions || [],
    multiplier: data.multiplier ?? fallback.multiplier ?? 1,
    cashout_value: data.cashout_value ?? fallback.cashout_value ?? 0,
    payout: data.payout ?? fallback.payout ?? 0,
  };
}

export function validStake(value) {
  const n = Number(value);
  return Number.isFinite(n) && n >= 0.01 && Number.isSafeInteger(Math.round(n * 100)) && Math.abs(n * 100 - Math.round(n * 100)) < 1e-7;
}

export function unpickedTiles(round) {
  const picked = new Set(round?.revealed || []);
  return Array.from({ length: 25 }, (_, i) => i).filter((i) => !picked.has(i));
}
